import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import Header from "../../components/globals/Header";
import AvailabililityInput from "../../components/inputs/AvailabililityInput";
import CategoriesSelectInput from "../../components/inputs/CategoriesSelectInput";
import ImagesUploadInput from "../../components/inputs/ImagesUploadInput";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import NormalInput2 from "../../components/inputs/NormalInput2";
import SimpleDropdownInput3 from "../../components/inputs/SimpleDropdownInput3";
import AddressModal from "../../components/modals/AddressModal";
import DiscountModal from "../../components/modals/DiscountModal";
import InfoModal2 from "../../components/modals/InfoModal2";
import ThankYouModal2 from "../../components/modals/ThankYouModal2";
import { types } from "../../dummyData";
import { useEventHooks } from "../../hooks/useEventHooks";
import { useTranslation } from "../../languages";
import { usePlaceHooks } from "../../hooks/UsePlacesHooks";
import StripePaymentModal from "../../components/modals/StripePaymentModal";
const AddEvent = () => {
  const {
    //all local states
    eventData,
    thankYouModalOpen,
    setThankYouModalOpen,
    setEventData,
    placesDropDownData,
    //all navigation
    goBack,
    //all functions
    onPressPayBtn
    ,clientSecret,setStripeModalOpen,setClientSecret,stripeModalOpen,
  } = useEventHooks();
  const { t } = useTranslation();
  const {placesListData}=usePlaceHooks();


  console.log("Stripe----Modal---Open",stripeModalOpen)

  return (
    <div>
      <Container fluid>
        <Header title={t("myEvents")} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <Button
            onClick={() => goBack()}
            className="standard-rounded-btn   py-2 inner-shadow-white"
          >
            {t("close")}
          </Button>
        </div>
        <Card className="border-none  app_gradient-background figma-card-radius p-0">
          <CardBody className="padding-top-42px padding-left-42px padding-right-42px">
            <div
              className="position-absolute d-none d-md-block "
              style={{ right: `2.63rem`, top: 16 }}
            >
              <InfoModal2
                text={eventData?.isSpecial===t("yes","GB")? t(`specialEventText`):t("eventText")}
                title={eventData?.isSpecial===t("yes","GB")?t(`specialEvent`):t("event")}
              />
            </div>
            <Row
              style={{ "--bs-gutter-y": "1.25rem" }}
              className=" justify-content-center"
            >
             
              <Col md={6}>
                <MultiSelectInput
                  label={t("type")}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, types: v }))
                  }
                  options={types}
                  value={eventData?.types ?? []}
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  label={t("title")}
                  placeholder={t("writeTitle")}
                  value={eventData?.title}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, title: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={"link"}
                  placeholder={t("writeReservationLinkHere")}
                  value={eventData?.reservationLink}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, reservationLink: v }))
                  }
                  label={t("reservationLink")}
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  labelClassName="figma-input-label-2"
                  label={t("price")}
                  placeholder={t("writeDealPrice")}
                  value={eventData?.price}
                  type={"number"}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, price: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <DiscountModal
                  label={t("offeredDiscounts")}
                  value={eventData?.discounts}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, discounts: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={"date"}
                  value={eventData?.startDate}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, startDate: v }))
                  }
                  label={t("startDate")}
                  labelClassName={"figma-input-label-2"}
                  placeholder={"Select Date"}
                />
              </Col>
              {/* <Col md={6}>
                <NormalInput2
                  type={"date"}
                  label={"End Date"}
                  value={eventData?.endDate}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, endDate: v }))
                  }
                  labelClassName={"figma-input-label-2"}
                  placeholder={"Select Date"}
                />
              </Col> */}
              <Col md={6}>
                <Label
                  style={{ marginBottom: "0.5rem" }}
                  className="figma-input-label d-block"
                >
                  {t("genderPreference")}
                </Label>
                <SimpleDropdownInput3
                  placeholder={t("selectOption")}
                  options={[t("male"), t("female"), t("both")]}
                  value={eventData?.genderPreference}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, genderPreference: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <AvailabililityInput
                  label={t("availability")}
                  value={eventData?.availability}
                  setAvailabilityValue={(v) =>
                    setEventData((prev) => ({ ...prev, availability: v }))
                  }
                  t={t}
                />
              </Col>
              <Col md={eventData?.isSpecial===t("yes","GB")?6:12}>
                <Label
                  style={{ marginBottom: "0.5rem" }}
                  className="figma-input-label d-block"
                >
                  {t("specialEvents")}
                </Label>
                <SimpleDropdownInput3
                  placeholder={t("selectOption")}
                  options={[t("yes","GB"), t("no","GB")]}
                  value={eventData?.isSpecial}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, isSpecial: v }))
                  }
                />
              </Col>
              {eventData?.isSpecial===t("yes","GB")&& <Col md={6}>
                <MultiSelectInput
                  label={t('enterYourPlaceName')}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, place: v }))
                  }
                  options={placesListData}
                  value={eventData?.place ?? []}
                  obj={true}
                />
              </Col>}
              <Col md={12}>
                <AddressModal
                  label={t("location")}
                  value={eventData?.location}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, location: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <CategoriesSelectInput
                  label={t("category")}
                  arrayValue={eventData?.categories ?? []}
                  setArrayValue={(v) =>
                    setEventData((prev) => ({ ...prev, categories: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <NormalInput2
                  label={t("description")}
                  placeholder={t("writeDescription")}
                  type={"textarea"}
                  value={eventData?.description}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, description: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <ImagesUploadInput
                  label={t("addPhotos")}
                  value={eventData?.photos ?? []}
                  maxImages={4}
                  setValue={(v) =>
                    setEventData((prev) => ({ ...prev, photos: v }))
                  }
                />
              </Col>
              <Col md={5} className="mt-5 mb-2">
                <Button
                  onClick={() => {
                    // setModalOpen(true);
                    onPressPayBtn();
                  }}
                  className="standard-rounded-btn full-width"
                >
                  {t("pay")} $5.00
                </Button>
              </Col>

            </Row>
          </CardBody>
        </Card>
      </Container>
      {/* modal */}




      <StripePaymentModal
        isOpen={stripeModalOpen}
        toggle={() => setStripeModalOpen((prev)=>!prev)}
        clientSecret={clientSecret}
        onPaymentSuccess={() => {
          setThankYouModalOpen(true); // show thank you modal
          setStripeModalOpen(false); // close payment modal
        }}
      />
      <ThankYouModal2
        isOpen={thankYouModalOpen}
        setisOpen={setThankYouModalOpen}
        text={`The amount has been Transferred successfully!. Your event is
            currently pending approval. We will notify you once our admin team
            approves it.`}
      />
    </div>
  );
};
export default AddEvent;
